import classNames from "classnames";

export function HeaderBullet({ className, children }: { className?: string; children: React.ReactNode | React.ReactNode[] }) {
  const baseClassNames =
    "relative flex items-center text-[14px] text-white font-bold pl-[14px] leading-[20px] before:content-[''] before:absolute before:left-0 before:w-[2px] before:h-[20px] before:rounded-[2px] before:bg-accent-blue-400";
  return <div className={classNames(baseClassNames, className)}>{children}</div>;
}
